module.exports = __webpack_public_path__ + "img/transportation-and-logistics-careers.8bbaf04f.jpg";